import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { RenewalsJanusServiceData } from './renewals-janus.model';
@Injectable({ providedIn: 'root' })
export class RenewalsJanusService {
  private dataSource = new BehaviorSubject<RenewalsJanusServiceData>({
    searchText:[],
    filterInputs:[],
    reRunJanusApplicationDataTable:false,
    attributeFilterInputs: [],
    columns: [],
    columnOptions: [],
    exportOptions: [],
    isEditorVisible: false,
  });

  data$ = this.dataSource.asObservable();

  /** Used to replace or partially update app data */
  setData(data: RenewalsJanusServiceData) {
    this.dataSource.next(data);
  }

  /** Getter for value (optional) */
  getData(): RenewalsJanusServiceData {
    return this.dataSource.value;
  }

  private bulkSelectionSubject = new BehaviorSubject<any[]>([]);
    bulkSelection$ = this.bulkSelectionSubject.asObservable();

    setBulkSelection(data: any[]) {
      this.bulkSelectionSubject.next(data);
    }

    private refreshTableSubject = new Subject<void>();
refreshTable$ = this.refreshTableSubject.asObservable();

triggerTableRefresh() {
  this.refreshTableSubject.next();
}
}
